import cx from "classnames";

import Counter from "ds/components/Counter";

import styles from "./styles.module.css";

type MainNavigationCounterProps = {
  count: number;
  inversed?: boolean;
  minimized?: boolean;
  className?: string;
};

const MainNavigationCounter = ({
  count,
  inversed,
  minimized,
  className,
}: MainNavigationCounterProps) => {
  if (count <= 0) {
    return null;
  }

  return (
    <Counter
      variant={inversed && !minimized ? "inversed" : "highlighted"}
      count={count > 99 ? "99+" : count}
      size={minimized ? "minimized" : "small"}
      className={cx(styles.counter, { [styles.minimized]: minimized }, className)}
    />
  );
};

export default MainNavigationCounter;
